import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import FlowChips from "../automations/FlowChips";
import ProductChip from "../automations/ProductChip";

const id = "modal-save-as-template";
const WHO = ["me", "team"];

// Saving an automation as a template: its name and description, what travels with it, and who can use it
const SaveAsTemplate = ({ detail, teamName, returnTo }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) => t(`emailAutomations.saveTemplate.${key}`, params);
  const [name, setName] = useState(detail?.automation.name ?? "");
  const [visibility, setVisibility] = useState("team");
  if (!detail) return null;
  const { automation, steps } = detail;

  return (
    <form
      action={`/actions/automations/${automation._id}/template`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="visibility" value={visibility} />
      <input type="hidden" name="returnTo" value={returnTo} />
      <Modal
        name={id}
        key={id}
        className="ea-modal ea-modal--save-template"
        customTitle={
          <h2 className="ea-modal__title">
            {tr("title")}
            <ProductChip product={automation.product} />
          </h2>
        }
      >
        <div className="body">
          <div className="ea-field ea-field--input">
            <label htmlFor="save-template-name">{tr("name")}</label>
            <input
              id="save-template-name"
              type="text"
              name="name"
              value={name}
              maxLength={100}
              required
              onChange={(event) => setName(event.target.value)}
            />
          </div>
          <div className="ea-field ea-field--input">
            <label htmlFor="save-template-description">
              {tr("description")}
            </label>
            <input
              id="save-template-description"
              type="text"
              name="description"
              maxLength={300}
              placeholder={tr("descriptionPlaceholder")}
            />
          </div>
          <div className="ea-field">
            <span>{tr("included")}</span>
            <div className="ea-included">
              <FlowChips automation={{ ...automation, steps }} />
              <p>{tr("includedNote")}</p>
            </div>
          </div>
          <fieldset className="ea-choices">
            <legend>{tr("who")}</legend>
            {WHO.map((choice) => (
              <label
                key={choice}
                className={`ea-choice${visibility === choice ? " ea-choice--selected" : ""}`}
              >
                <input
                  type="radio"
                  name="who"
                  value={choice}
                  className="sr-only"
                  checked={visibility === choice}
                  onChange={() => setVisibility(choice)}
                />
                <i className="ea-choice__radio" aria-hidden="true" />
                <strong>{tr(`${choice}.title`, { team: teamName })}</strong>
                <span>{tr(`${choice}.body`)}</span>
              </label>
            ))}
          </fieldset>
        </div>
        <footer className="foot">
          {/* biome-ignore lint/a11y/useSemanticElements: a real link so Rill navigates; role only picks up button styles */}
          <a
            href="/actions/refresh?modal=&automation="
            data-button-type="secondary"
            data-action="cancel"
            role="button"
          >
            {tr("cancel")}
          </a>
          <button type="submit" data-button-type="primary">
            {tr("save")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

SaveAsTemplate.propTypes = {
  detail: PropTypes.shape({
    automation: PropTypes.object,
    steps: PropTypes.array,
  }),
  teamName: PropTypes.string,
  returnTo: PropTypes.string.isRequired,
};

export default SaveAsTemplate;
